export const LOAD_PRODUCTS = 'load_products';
export const LOAD_PRODUCTS_BY_IDS = 'load_products_by_ids';
export const LOAD_PRODUCTS_ATTRIBUTES = 'load_products_attributes';
export const PRODUCTS_LOADED = 'set_loaded_products';
export const PRODUCTS_BY_IDS_LOADED = 'set_loaded_product';
export const PRODUCTS_ATTRIBUTES_LOADED = 'set_loaded_products_attributes';
export const SEARCH_PRODUCTS = 'search_products';
export const SEARCH_PRODUCTS_LOADED = 'set_searched_products';
export const RESET_PRODUCTS = 'reset_products';
export const RESET_SEARCH_PRODUCTS = 'reset_search_products';
export const SYNC_FAILED = 'products_sync_has_failed';
